import { Update } from '@ngrx/entity';

import { DiscussionListItem, DiscussionModel } from '../discussion.models';
import { DiscussionDetailFormValue } from '../form/discussion-detail-form';

export type PatchDiscussionDto = Partial<
  Pick<DiscussionModel, 'title' | 'description' | 'dueDate' | 'periodStartDate' | 'periodEndDate' | 'isDeleted'>
>;

export class PatchDiscussionDtoImpl {
  static create(discussion: DiscussionModel, update: DiscussionDetailFormValue): PatchDiscussionDto {
    if (update.dueDate) update.dueDate = new Date(update.dueDate).toISOString();
    if (update.periodStartDate) update.periodStartDate = new Date(update.periodStartDate).toISOString();
    if (update.periodEndDate) update.periodEndDate = new Date(update.periodEndDate).toISOString();
    return Object.entries(update).reduce((acc, [key, updateVal]) => {
      const k = key as keyof PatchDiscussionDto;
      const originalVal = discussion[k];

      if (updateVal === undefined || updateVal === originalVal) return acc;

      acc[k] = updateVal;

      return acc;
    }, {} as PatchDiscussionDto);
  }

  static createActionPayload(discussion: DiscussionModel, update: PatchDiscussionDto): Update<DiscussionListItem> {
    return {
      id: discussion._id,
      changes: {
        title: update.title ?? discussion.title,
        dueDate: update.dueDate ? new Date(update.dueDate) : discussion.dueDate,
      },
    };
  }
}
